export default __webpack_public_path__ + "static/char-12-6568369cdf934e59eb2cb5659f7d9a69.gif";